import { User } from "./auth.models";

export enum CompanyStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    PENDING = 'PENDING',
}

export enum CompanyType {
    CUSTOMER = 'CUSTOMER',
    PARTNER = 'PARTNER',
}
export class CompanyModel {
    id: number;
    type: CompanyType;
    name: string;
    email: string;
    website: string | null;
    logo: any;
    phone1: string | null;
    phone2: string | null;

    status: CompanyStatus;

    address: string | null;
    country: string | null;
    postalCode: string | null;
    preferredTimezone: string | null;

    businessActivity: string | null;
    taxFileNumber: string | null;

    accountManagerId: number | null;
    partnerId: number | null;

    accountManager: User | null;
    partner: CompanyModel | null;

    constructor($obj: any) {
        this.id = $obj && $obj.id ? $obj.id : null;
        this.type = $obj && $obj.type ? $obj.type : CompanyType.PARTNER;
        this.name = $obj && $obj.name ? $obj.name : '';
        this.email = $obj && $obj.email ? $obj.email : '';
        this.website = $obj && $obj.website ? $obj.website : null;
        this.logo = $obj && $obj.logo ? $obj.logo : '';
        this.phone1 = $obj && $obj.phone1 ? $obj.phone1 : null;
        this.phone2 = $obj && $obj.phone2 ? $obj.phone2 : null;
        this.status = $obj && $obj.status ? $obj.status : CompanyStatus.ACTIVE;

        this.address = $obj && $obj.address ? $obj.address : null;
        this.country = $obj && $obj.country ? $obj.country : null;
        this.postalCode = $obj && $obj.postalCode ? $obj.postalCode : null;
        this.preferredTimezone = $obj && $obj.preferredTimezone ? $obj.preferredTimezone : null;

        this.businessActivity = $obj && $obj.businessActivity ? $obj.businessActivity : null;
        this.taxFileNumber = $obj && $obj.taxFileNumber ? $obj.taxFileNumber : null;

        this.accountManagerId = $obj && $obj.accountManagerId ? $obj.accountManagerId : $obj && $obj.accountManager ? $obj && $obj.accountManager.id : null;
        this.partnerId = $obj && $obj.partnerId ? $obj.partnerId : $obj && $obj.partner ? $obj && $obj.partner.id : null;

        this.accountManager = $obj && $obj.accountManager ? $obj.accountManager : null;
        this.partner = $obj && $obj.partner ? $obj.partner : null;
    }

    get isActive(): boolean { return this.status === CompanyStatus.ACTIVE; }
    get isInactive(): boolean { return this.status === CompanyStatus.INACTIVE }
    get isCustomer(): boolean { return this.type === CompanyType.CUSTOMER }
    get isPartner(): boolean { return this.type === CompanyType.PARTNER }
}


